/**
 * Severity of a notification. Drives the icon, colour palette and the ARIA
 * politeness level used when the toast is announced.
 */
export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  /** Caller supplies its own icon / panelClass. */
  Custom = 'custom',
}

/**
 * Where a stack of toasts is anchored on screen. Each position owns its own
 * CDK overlay, so notifications at different positions never interleave.
 */
export enum NotificationPosition {
  TopLeft = 'top-left',
  TopCenter = 'top-center',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomCenter = 'bottom-center',
  BottomRight = 'bottom-right',
}

/** Why a toast left the screen — forwarded to `NotificationRef.afterDismissed()`. */
export enum NotificationDismissReason {
  /** The auto-dismiss timer elapsed. */
  Timeout = 'timeout',
  /** The user pressed the close button, Escape, or tapped the toast. */
  User = 'user',
  /** The action button was pressed and `dismissOnAction` was true. */
  Action = 'action',
  /** `dismiss()` / `dismissAll()` was called, or the stack limit pushed it out. */
  Programmatic = 'programmatic',
}

/** Ready-made action buttons matching the common recovery affordances. */
export enum NotificationActionPreset {
  Retry = 'retry',
  Refresh = 'refresh',
  Undo = 'undo',
}

/** Colour scheme applied to every stack. `Auto` follows `prefers-color-scheme`. */
export enum NotificationTheme {
  Light = 'light',
  Dark = 'dark',
  Auto = 'auto',
}
